import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-dynamic-phone-number',
  templateUrl: './dynamic-phone-number.component.html',
  styleUrls: ['./dynamic-phone-number.component.scss']
})
export class DynamicPhoneNumberComponent implements OnInit {


  @Input() isd_formControl;
  @Input() form;
  @Input() masters;
  @Input() isd_label;
  @Input() isd_placeholder;
  @Input() disabled;
  @Input() mandatory;
  @Input() mobile_number_placeholder;
  @Input() mobile_number_form_control;

  constructor() { }

  ngOnInit(): void {
    // console.log(this.form);
  }
  ngOnChanges(changes: SimpleChanges): void {
    // console.log(changes);
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.

  }

}
